module.exports = __webpack_public_path__ + "img/level3addon_idle_gun.d5d7cef8.png";